export const actionRow = {
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  gap: "16px",
  padding: "5px 5px 0",
};

export const inputRow = {
  padding: "10px 5px",
};

export const commonInputStyles: any = {
  className: "backgroundWhite-description",
  size: "small",
  variant: "outlined",
  fullWidth: true,
};
